export default [
    {
        label: "Úlohy",
        to: "/dtmk/ulohy",
    },
];
